import { FieldParams } from "./FieldObject";
import { DeepMergeObject, DotStringToObject } from "./Helper";
import { FieldDataType, FormControlType } from "./Helper2";

export const cancleClick = (item, setObject) => {
  if (!setObject) return;
  setObject((pv) => ({
    ...pv,
    ...DeepMergeObject(
      DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
      DotStringToObject(item.fieldName + "." + item.searchDisplayName, null)
    ),
  }));
};

export const GetBillingNoteHeaderObject = (props) => {
  const {
    docuList,
    onSelectDocument,
    docuFieldIdName,
    head,
    custClick,
    sectionId,
  } = props;

  const maxWidth = "120px";
  if (sectionId === 1)
    return {
      [docuFieldIdName]: {
        ...new FieldParams(
          docuFieldIdName,
          "DocuId",
          true,
          FieldDataType.NUMERIC,
          FormControlType.HIDDEN
        ),
      },

      BranchDocu: {
        ...new FieldParams(
          "DocuBranch",
          "ประเภทเอกสาร",
          true,
          FieldDataType.NUMERIC,
          FormControlType.SELECT
        ),
        selectData: docuList,
        selectHasFirstOption: false,
        selectBuildObjectPath: "DocuBranch.BranchDocu",
        selectValueName: "DocuBrchId",
        selectDisplayName: "DocuType.DocuTypeName", // [docuList].DocuType.DocuTypeName
        onChange: onSelectDocument,
        disabled: head?.[docuFieldIdName] ? true : false,
      },
      DocuNo: {
        ...new FieldParams(
          "DocuNo",
          "เลขที่เอกสาร",
          true,
          FieldDataType.TEXT,
          null,
          head?.DocuNo ?? null
        ),
        disabled: true, // head?.[docuFieldIdName] ? true : false,
      },
      DocuDate: {
        ...new FieldParams(
          "DocuDate",
          "วันที่เอกสาร",
          true,
          FieldDataType.DATE,
          FormControlType.DATE_PICKER
        ),
        disabled: head?.[docuFieldIdName] ? true : false,
      },
    };
  else if (sectionId === 2)
    return {
      Customer: {
        ...new FieldParams(
          "Customer",
          "ตั้งเบิกกับ",
          true,
          FieldDataType.NUMERIC,
          FormControlType.SEARCHER
        ),
        tableColumnFieldName: "Customer.CustShortName",
        searchDisplayName: "CustShortName",
        searchValueName: "CustId",
        searchButtonClick: custClick,
        searchCancelClick: cancleClick,
        hidden: false,
        labelStyle: { maxWidth, flex: "none" },
      },

      BillTo: {
        ...new FieldParams("BillTo", "ออกให้กับ", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
      Addr1: {
        ...new FieldParams("BillAddr1", "ที่อยู่", null, null, null),

        labelStyle: { maxWidth, flex: "none" },
      },

      Addr2: {
        ...new FieldParams("BillAddr2", "", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
      Phone: {
        ...new FieldParams("BillPhone", "เบอร์โทร", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
    };
  else if (sectionId === 3) {
    return {
      NetTotal: {
        ...new FieldParams(
          "NetTotal",
          "รวมทั้งสิ้น",
          true,
          FieldDataType.NUMERIC,
          FormControlType.DECIMAL_LOCK_VALUE
        ),
        readOnly: true,
      },
    };
  }
};
